import {
  GQLGetLoanPermissionByAccountAndLoan,
  IGQLPermissionVariable
} from 'src/services/grapqlQueries/permissionQuery';
import {
  useReactQuery,
} from 'src/queries/useQuery';
import { queryPresets } from 'src/queries/base';


export const usePermissionByNamespaceLoan = (
  queryKey: string,
  loanAppId: string,
  variables: IGQLPermissionVariable,
  enabled: boolean = true
) => {
  return useReactQuery(
    [queryKey, loanAppId],
    () => GQLGetLoanPermissionByAccountAndLoan(variables),
    {
      ...queryPresets.oneTimeFetch,
      enabled,
      retry: true,
    }
  )
};
